import { BRAND, createI18n } from '@signbento/ui'
import '@signbento/ui/styles.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './app/App.js'
import { registerAppServiceWorker } from './lib/app-update.js'
import { applyAppearance, appearanceStorage, readAppearance } from './lib/appearance.js'
import { startNativeShell } from './lib/native-shell.js'
import { VaultProvider } from './lib/vault-context.js'
import { installViewportInsets } from './lib/visual-viewport.js'
import { raisesKeyboard } from './lib/keyboard-tap.js'
import './styles.css'

document.title = BRAND.product_name

const i18n = createI18n({ locale: 'en' })

// The appearance preference is applied before the shell's first paint. An explicit choice wins over
// the device setting; no choice leaves the device in charge, so the shell opens in its theme with
// no flash of the other one.
applyAppearance(document.documentElement, readAppearance(appearanceStorage()))

// The installed app's keyboard and text size (a browser skips it), and in a browser the keyboard's
// height for sheets and bottom bars, which `position: fixed` would otherwise leave behind it.
void startNativeShell()
installViewportInsets(document, (active) => raisesKeyboard(active))

const container = document.getElementById('root')
if (container === null) {
  throw new Error('Missing #root container')
}

createRoot(container).render(
  <StrictMode>
    <VaultProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </VaultProvider>
  </StrictMode>,
)

// PWA service worker: the offline shell and the safe version handshake; it never reloads a draft
// on its own (PLT-10, §11.8).
registerAppServiceWorker(i18n)
